import axios from 'axios';

const API_PREFIX = 'api/fe/landings';

function getStaticData(domain = '', path) {
  const url = `${domain}/${API_PREFIX}/static-data/${path}`;
  const options = {};

  return axios.get(url, options);
}

export { getStaticData };
